var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(-48 -201.76)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 24,
    height: 24,
    transform: "translate(48 201.76)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "export",
    d: "M7.81,2C4.17,2,2,4.17,2,7.81v8.37C2,19.83,4.17,22,7.81,22h8.37c3.64,0,5.81-2.17,5.81-5.81V7.81C22,4.17,19.83,2,16.19,2ZM16.5,13.08a.755.755,0,0,1-.75-.75V9.31L8.03,17.03a.748.748,0,0,1-1.06,0,.754.754,0,0,1,0-1.06l7.72-7.72H11.67a.75.75,0,0,1,0-1.5H16.5a.755.755,0,0,1,.75.75v4.83A.755.755,0,0,1,16.5,13.08Z",
    transform: "translate(48.005 201.76)",
    fill: "#15345a",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.4d89ca25b45129a10f69e44666f6d413.svg";
export { ForwardRef as ReactComponent };